import {Dropdown, DropDownExtension} from "@core/types/dropdown.type";
import {Injectable} from '@angular/core';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {environment} from '@environments/environment';
import {catchError, Observable, throwError} from 'rxjs';
import {ApiResponse} from '@core/types/api-response.type';

@Injectable({
  providedIn: 'root',
})
export class DropdownService {
  baseUrl: string;

  constructor(private httpClient: HttpClient) {
    this.baseUrl =  environment.api + '/dropdown';
  }

  condominiumTypes(): Observable<ApiResponse<DropDownExtension<string, boolean>[]>> {
    return this.httpClient.get<ApiResponse<DropDownExtension<string, boolean>[]>>(
      this.baseUrl + "/condominiumtypes",
    ).pipe(
      catchError((errorReponse: HttpErrorResponse) => {
        return throwError(() => `${errorReponse.error.message}`);
      })
    );
  }

  zones(): Observable<ApiResponse<Dropdown<string>[]>> {
    return this.httpClient.get<ApiResponse<Dropdown<string>[]>>(
      this.baseUrl + "/zones",
    ).pipe(
      catchError((errorReponse: HttpErrorResponse) => {
        return throwError(() => `${errorReponse.error.message}`);
      })
    );
  }

  commonAreaStatuses(): Observable<ApiResponse<Dropdown<string>[]>> {
    return this.httpClient.get<ApiResponse<Dropdown<string>[]>>(
      this.baseUrl + "/commonareastatuses",
    ).pipe(
      catchError((errorReponse: HttpErrorResponse) => {
        return throwError(() => `${errorReponse.error.message}`);
      })
    );
  }

  reservationStatuses(): Observable<ApiResponse<Dropdown<string>[]>> {
    return this.httpClient.get<ApiResponse<Dropdown<string>[]>>(
      this.baseUrl + "/reservationstatuses",
    ).pipe(
      catchError((errorReponse: HttpErrorResponse) => {
        return throwError(() => `${errorReponse.error.message}`);
      })
    );
  }

  documents(): Observable<ApiResponse<Dropdown<string>[]>> {
    return this.httpClient.get<ApiResponse<Dropdown<string>[]>>(
      this.baseUrl + "/documents",
    ).pipe(
      catchError((errorReponse: HttpErrorResponse) => {
        return throwError(() => `${errorReponse.error.message}`);
      })
    );
  }

  IdentificationType: Dropdown<number>[] = [
    { value: 1, label: 'Cedula'},
    { value: 2, label: 'Passporte'},
    { value: 3, label: 'Otro'}
  ];

  SelectLanguageEn: Dropdown<string>[] = [
    { value: 'es', label: 'Spanish'},
    { value: 'en', label: 'English'}
  ];

  SelectLanguageEs: Dropdown<string>[] = [
    { value: 'es', label: 'Español'},
    { value: 'en', label: 'Inglés'}
  ];
}
